import DOMPurify from 'dompurify';

import {Nullish} from 'shared/web';

import {openEmailLinksInNewTab} from './openEmailLinksInNewTab';

/**
 * Sanitizes an email body for inline rendering (dangerouslySetInnerHTML) and makes its web links
 * open in a new tab. RETURN_DOM_FRAGMENT hands back the sanitized nodes as a DocumentFragment, so
 * the links are adjusted on that DOM directly instead of re-parsing the serialized string; the
 * fragment is then serialized through a detached container (fragments have no innerHTML).
 */
export function sanitizeEmailHtml(html: string | Nullish) {
  const fragment = DOMPurify.sanitize(html ?? '', {RETURN_DOM_FRAGMENT: true});
  openEmailLinksInNewTab(fragment);
  const container = document.createElement('div');
  container.append(fragment);
  return container.innerHTML;
}
